import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Administration',
		icon: 'acies_organization',
		path: 'administration',
		overlay: false,
		permission: 'mes:EmployeeGet',
		parents: ['AciesMes'],
		children: [
			{
				label: 'Worktasks',
				icon: 'acies_worktasks',
				path: 'mes/worktasks',
				overlay: false,
				children: [],
				permission: 'mes:WorkTaskGet',
				parents: ['AciesMes', 'Administration'],
				forceTranslateKey: 'mes.administration.worktasks.worktasks',
			},
			{
				label: 'Calendar',
				icon: 'acies_calendar',
				path: 'mes/calendar',
				overlay: false,
				children: [],
				permission: 'mes:CalendarGet',
				parents: ['AciesMes', 'Administration'],
				forceTranslateKey: 'mes.administration.calendar.calendar',
			},
			{
				label: 'Team Profiles',
				icon: 'acies_teamprofiles',
				path: 'mes/team-profiles',
				overlay: false,
				children: [],
				permission: 'mes:TeamProfileGet',
				parents: ['AciesMes', 'Administration'],
				forceTranslateKey: 'mes.administration.team-profiles.team-profiles',
			},
			{
				label: 'Department',
				icon: 'acies_departments',
				path: 'mes/mes-department',
				overlay: false,
				children: [],
				permission: 'mes:DepartmentGet',
				parents: ['AciesMes', 'Administration'],
				forceTranslateKey: 'mes.administration.department.departments',
			},
			{
				label: 'Users',
				icon: 'acies_user',
				path: 'mes/users',
				overlay: false,
				children: [],
				permission: 'mes:EmployeeGet',
				parents: ['AciesMes', 'Administration'],
				forceTranslateKey: 'mes.administration.users.employees',
			},
		],
	},
	{
		label: 'Produktion',
		icon: 'acies_production',
		path: 'produktion',
		overlay: false,
		permission: 'mes:EmployeeStampIn',
		parents: ['AciesMes'],
		children: [
			{
				label: 'TerminalTemplate',
				icon: 'acies_template',
				path: 'mes/terminaltemplate-administration',
				overlay: false,
				children: [],
				permission: 'mes:TerminalGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.administration.terminaltemplate.terminaltemplate',
			},
			{
				label: 'Terminal',
				icon: 'acies_terminals',
				path: 'mes/terminal-administration',
				overlay: false,
				children: [],
				permission: ['mes:TerminalGet', 'mes:WorkTaskGet', 'mes:IncidentCodeGet'],
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.administration.terminal.terminal',
			},
			{
				label: 'Batch',
				icon: 'acies_batch',
				path: 'mes/mes-batch',
				overlay: false,
				children: [],
				permission: 'mes:BatchGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.administration.batch.batch',
			},
			{
				label: 'Stock reorder',
				icon: 'acies_mes_stockreorders',
				path: 'mes/stock-reorder',
				overlay: false,
				children: [],
				permission: 'mes:ReorderGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.stock-reorder.stockreorder',
			},
			{
				label: 'Scanning Prefix',
				icon: 'acies_label',
				path: 'mes/scanning-prefix',
				overlay: false,
				children: [],
				permission: 'mes:ScanningPrefixGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.scanning-prefix.label',
			},
			{
				label: 'Production Note',
				icon: 'acies_mes_production_notes',
				path: 'mes/production-note',
				overlay: false,
				children: [],
				permission: 'mes:ProductionNoteGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.production-notes.label',
			},
			{
				label: 'Incident Code',
				icon: 'acies_mes_incident_code',
				path: 'mes/incident-code',
				overlay: false,
				children: [],
				permission: 'mes:IncidentCodeGet',
				parents: ['AciesMes', 'Produktion'],
				forceTranslateKey: 'mes.incident-code.label',
			},
		],
	},
	// {
	// 	label: 'Productionplans',
	// 	icon: 'acies_mes_production_plan',
	// 	path: 'mes/production-plan',
	// 	overlay: false,
	// 	children: [],
	// 	permission: 'mes:ProductionPlanGet',
	// 	parents: ['AciesMes'],
	// 	forceTranslateKey: 'mes.production-plan.label',
	// },
	{
		label: 'Production plans',
		icon: 'acies_mes_production_plan',
		path: 'mes/production-plan-admin',
		overlay: false,
		children: [],
		permission: 'reporting:ProductionPlanGet',
		parents: ['AciesMes'],
		forceTranslateKey: 'mes.production-plan.label',
	},
	{
		label: 'Timestamp Validation',
		icon: 'acies_timestamps',
		path: 'mes/shift-approval',
		overlay: false,
		children: [],
		permission: ['mes:ShiftGet', 'mes:DepartmentGet', 'mes:EmployeeGet', 'mes:TeamProfileGet', 'mes:WorkTaskGet'],
		parents: ['AciesMes'],
		forceTranslateKey: 'mes.administration.shift-approval.shift-approval',
	},
];
